import Button from 'components/form/Button';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { downloadResume, downloadResumeTxt } from 'store/slices';
import { cvPdfDownload, icons, profilePath } from 'utils/constants';
import {
  downloadFile,
  generatePreSignedUrl,
  getDataFromLocalStorage,
} from 'utils/helpers';

const CVPreview = ({ userDetails, researchProfile, list }) => {
  const dispatch = useDispatch();
  const [loading, setloading] = useState(false);
  const [s3URL, setS3URL] = useState('');
  const [userIsFree, setUserIsFree] = useState(false);
  const reduxData = useSelector((state) => state.global);
  const { resumeList, aiCreditCheck } = reduxData;
  const {
    profile_details,
    educational_details,
    about,
    research_id,
    affiliations = [],
    publication = [],
    achievements = [],
  } = researchProfile || {};
  let userID = getDataFromLocalStorage('id');

  const {
    personal_details,
    professional_details,
    ai_credits,
    membership_plan_id,
  } = userDetails || [];
  const pastExperiences = affiliations?.find(
    (o) => o?.user_id === userDetails?.id
  );
  const currentPosition = professional_details
    ? {
        id: professional_details?.id,
        position: professional_details.designation,
        institution: professional_details.institution_name,
        department: professional_details.department,
        country_name: professional_details.country_name,
        state_name: professional_details.state_name,
      }
    : null;
  const previousPosition = pastExperiences
    ? {
        id: pastExperiences.id,
        position: pastExperiences.position,
        institution: pastExperiences.institution,
        department: pastExperiences.department,
        startDate: pastExperiences.start_date,
        endDate: pastExperiences.end_date,
        country_name: pastExperiences.country_name,
        city_name: pastExperiences.city_name,
      }
    : null;

  const type =
    userDetails && userDetails?.user_type === '0'
      ? 'Admin'
      : userDetails?.user_type === '1'
      ? 'Super Admin'
      : userDetails?.user_type === '2'
      ? 'Professional'
      : userDetails?.user_type === '3'
      ? 'Institution'
      : userDetails?.user_type === '4'
      ? 'Corporate'
      : userDetails?.user_type === '5'
      ? 'Student'
      : '';

  const InfoBlock = ({ icon, label, value }) =>
    value && (
      <>
        <div className="fa-center gap-2 flex-nowrap cmb-4">
          {/* <div className="w-14 h-14 f-center">
            <img src={icon} alt="" className="fit-image" loading="lazy" />
          </div> */}
          <div className="text-12-400 color-black-olive">
            {label}: {value}
          </div>
        </div>
      </>
    );
  const InfoBlockWithList = ({ icon, label, items, isDeclare }) =>
    items && (
      <>
        <div className="fa-center gap-2 flex-nowrap cmb-14">
          {/* <div className="w-18 h-18 f-center">
            <img src={icon} alt="" className="fit-image" loading="lazy" />
          </div> */}
          <div className="text-14-500 color-48c0">{label}</div>
        </div>
        <ul
          className="list-style-none"
          style={{
            listStyleType: isDeclare ? 'none' : 'disc',
            paddingLeft: isDeclare && '0px',
          }}
        >
          {items.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </>
    );
  const EmpBlock = ({
    position,
    institution,
    startDate,
    endDate,
    country_name,
    state_name,
    city_name,
  }) => {
    return (
      <div className="empList">
        <ul className="list-style-none">
          <li>
            <strong>Position Title :</strong> {position}
          </li>
          <li>
            <strong>Institution :</strong>{' '}
            {`${institution}, ${state_name || city_name} ${country_name}  `}
          </li>
          {(startDate || endDate) && (
            <li>
              <strong>Duration :</strong> {`${startDate} - ${endDate}`}
            </li>
          )}
        </ul>
      </div>
    );
  };
  const JorBlock = ({ title, items }) =>
    title && (
      <div className="jorList">
        <div className="fb-center flex-norap cmb-8">
          <div className="text-14-500 color-1717">{title}</div>
        </div>
        <ul className="list-style-none">
          {items && <li>{items || '---'}</li>}
        </ul>
      </div>
    );
  const AcheiBlock = ({ title, items }) => (
    <div className="acheiList cmb-10">
      <div className="fb-center flex-norap cmb-8">
        <ul className="list-style-none mb-0">
          <li className="text-12-400 color-3d3d">{title}</li>
        </ul>
      </div>
      {items && (
        <ul className="list-style-none">
          <li>{items}</li>
        </ul>
      )}
    </div>
  );
  // const PubBlock = ({ data }) => (
  //   <div className="pubList cmb-10">
  //     <ul className="list-style-none mb-0">
  //       <li className="text-12  -400 color-3d3d mb-0">
  //         {`${data.author_details.name}, "${data.paper_title}," ${data.no_of_pages}`}
  //       </li>
  //     </ul>
  //   </div>
  // );

  const PubBlock = ({ data }) => {
    const coAuthorsNames = data.co_authors
      .map((coAuthor) => coAuthor.name)
      .join(', ');

    return (
      <div className="pubList cmb-10">
        <ul className="list-style-none mb-0">
          <li className="text-12 -400 color-3d3d mb-0">
            {`${data.author_details.name}${
              coAuthorsNames ? `, ${coAuthorsNames}` : ''
            }, "${data.paper_title}", ${data.no_of_pages}`}
          </li>
        </ul>
      </div>
    );
  };

  const EduBlock = ({ title, department, university, date, institution }) =>
    title && (
      <>
        <ul className="list-style-none">
          <li className="text-14-500 color-1717">
            {`${title} in ${department}`}
            <ul className="list-style-none">
              <li className="text-12-400 color-3d3d">{`${university}, ${institution}`}</li>
              <li className="text-12-400 color-3d3d">{date}</li>
            </ul>
          </li>
        </ul>
      </>
    );

  const fetchProfile = async (profileName) => {
    let retunURL = '';
    const response = await generatePreSignedUrl(profileName, profilePath);
    retunURL = response;
    setS3URL(retunURL);
  };

  const handleCvDownload = async () => {
    setUserIsFree(false);
    setloading(true);
    if ([2, 11, null].includes(membership_plan_id)) {
      setUserIsFree(true);
    } else {
      const formData = new FormData();
      let data = { about: [{}] };
      if (Object.keys(data).length === 0) {
        const maskedIntroduction = aiCreditCheck
          ? `I Am ${'*'.repeat(120)} \n ${'*'.repeat(100)}`
          : about.introduction || '';

        data.about[0].introduction = maskedIntroduction || '';
        data.profile_summary = maskedIntroduction || '';
      } else if (data?.about && data?.about[0]) {
        const maskedIntroduction = aiCreditCheck
          ? `I Am ${'*'.repeat(120)} \n ${'*'.repeat(100)}`
          : about.introduction || '';
        data.about[0].introduction = maskedIntroduction || '';
        data.profile_summary = maskedIntroduction || '';
      }
      formData.append('resume_data', JSON.stringify(data));
      formData.append('user_id', userDetails?.user_id || userID);
      const res = await dispatch(downloadResume(formData));
      if (res?.status === 200) {
        const fileName = res.data.file;
        const res1 = await generatePreSignedUrl(fileName, cvPdfDownload);
        dispatch(downloadFile(res1));
      }
    }
    setloading(false);
  };

  useEffect(() => {
    if (profile_details?.profile_photo) {
      fetchProfile(profile_details?.profile_photo);
    } else {
      setS3URL(profile_details?.profile_photo);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile_details?.profile_photo]);

  const params = useParams();
  const { memberType } = params;
  return (
    <div className="h-100vh overflow-auto iferp-scroll bg-d180 cps-25 cpe-25 cpt-32 cpb-32">
      <div className="cmb-4 d-flex align-items-center justify-content-start gap-3 flex-nowrap">
        <div>
          <Button
            text="Download PDF"
            icon={
              <img
                src={icons.bPdf}
                alt=""
                loading="lazy"
                className="w-16 h-16 cme-10"
              />
            }
            btnStyle="AI"
            onClick={handleCvDownload}
            loading={loading}
            disabled={loading}
          />
        </div>
      </div>
      {userIsFree && (
        <p className="color-danger">
          To download the PDF upgrade to a{' '}
          <a href={`/${memberType}/upgrade`} className="btn-link">
            Premium Membership
          </a>
        </p>
      )}
      <div className="cvBlock iferp-scroll cmt-20">
        <div className="cpt-14 cpb-14 cps-14 cpe-14 headBlock">
          <div className="d-flex gap-3">
            <div className="w-102 h-102 d-flex align-items-center justify-content-center">
              <img src={s3URL} alt="" loading="lazy" className="fit-image" />
            </div>
            <div className="flex-grow-1">
              <div className="fb-center flex-nowrap cmb-10">
                <div className="text-22-600 color-1717">
                  {`${profile_details?.first_name} ${profile_details?.last_name}` ||
                    '--'}
                </div>
              </div>
              <Row className="row-gap-2">
                <Col md={6}>
                  {userDetails?.phone_number && (
                    <InfoBlock
                      icon={icons.bPhone}
                      label="Phone"
                      skills_and_expertise
                      value={`+${userDetails?.phone_code} ${userDetails?.phone_number}`}
                    />
                  )}
                  {personal_details?.date_of_birth && (
                    <InfoBlock
                      icon={icons.bCalender}
                      label="DOB"
                      value={
                        personal_details?.date_of_birth &&
                        moment(personal_details?.date_of_birth).format(
                          'DD-MMM-YYYY'
                        )
                      }
                    />
                  )}
                  {personal_details?.date_of_birth && (
                    <InfoBlock
                      icon={icons.bMail}
                      label="Email"
                      value={userDetails?.email_id}
                    />
                  )}
                </Col>
                <Col md={6}>
                  {personal_details?.country_name && (
                    <InfoBlock
                      icon={icons.bGlobe}
                      label="Country"
                      value={personal_details?.country_name}
                    />
                  )}
                  {personal_details?.gender && (
                    <InfoBlock
                      icon={icons.bGender}
                      label="Gender"
                      value={personal_details?.gender}
                    />
                  )}
                </Col>
              </Row>
            </div>
          </div>
        </div>
        <div className="mainCvBlock">
          <Row className="ms-0 me-0 ps-0 pe-0">
            <Col md={12} className="ps-0 pe-0">
              {about?.introduction?.length !== 0 && about?.introduction && (
                <div className="br-f4fc cps-14 cpe-14 cpt-14">
                  <div className="text-14-500 color-48c0 cmb-8">
                    CAREER OBJECTIVE
                  </div>
                  {aiCreditCheck ? (
                    <div
                      className="text-12-400 color-dark-gray"
                      style={{ whiteSpace: 'pre-wrap' }}
                    >
                      {`I Am ${'*'.repeat(120)} \n ${'*'.repeat(100)} `}
                    </div>
                  ) : (
                    <div
                      className="text-12-400 color-dark-gray"
                      style={{ whiteSpace: 'pre-wrap' }}
                    >
                      {about?.introduction?.length !== 0 && about?.introduction}
                    </div>
                  )}
                  <hr className="b-d1d1" />
                </div>
              )}
              {research_id?.length > 0 && (
                <div className="br-f4fc cps-14">
                  <div className="text-14-500 color-48c0 cmb-8">
                    RESEARCH IDs
                  </div>
                  <ul className="text-12-400 color-dark-gray">
                    {research_id.map((item, index) => (
                      <li key={index}>
                        <strong>{item.name}:</strong> {item.number}
                      </li>
                    ))}
                  </ul>
                  <hr className="b-d1d1" />
                </div>
              )}
              {(currentPosition?.position || previousPosition?.position) && (
                <div className="cps-14 cpe-14">
                  <div className="fa-center gap-2 flex-nowrap cmb-22">
                    <div className="text-14-500 color-48c0">
                      EMPLOYEMENT HISTORY
                    </div>
                  </div>
                  {currentPosition?.position && (
                    <div className="emp-section">
                      <h3 className="text-14-400 color-1717">
                        CURRENT POSITION
                      </h3>
                      <EmpBlock
                        position={currentPosition.position}
                        institution={currentPosition.institution}
                        department={currentPosition.department}
                        country_name={currentPosition.country_name}
                        state_name={currentPosition.state_name}
                        city_name={
                          currentPosition?.city_name
                            ? currentPosition?.city_name
                            : ''
                        }
                      />
                    </div>
                  )}
                  {previousPosition?.position && (
                    <div className="emp-section">
                      <h3 className="text-14-400 color-1717">
                        PREVIOUS POSITIONS
                      </h3>
                      <EmpBlock
                        position={previousPosition.position}
                        institution={previousPosition.institution}
                        department={previousPosition.department}
                        startDate={
                          previousPosition.startDate &&
                          moment(previousPosition.startDate).format(
                            'DD-MMM-YYYY'
                          )
                        }
                        endDate={
                          previousPosition.endDate &&
                          moment(previousPosition.endDate).format('DD-MMM-YYYY')
                        }
                        country_name={previousPosition.country_name}
                        city_name={previousPosition.city_name}
                      />
                    </div>
                  )}
                  <hr className="b-d1d1" />
                </div>
              )}
              <div className="br-f4fc cps-14 cpe-14">
                <Row>
                  {(educational_details?.ug_course ||
                    educational_details?.pg_course ||
                    educational_details?.phd_course) && (
                    <Col md={12}>
                      <>
                        <div className="fa-center gap-2 flex-nowrap cmb-14">
                          <div className="text-14-500 color-48c0">
                            EDUCATION
                          </div>
                        </div>

                        {/* PhD */}
                        {educational_details?.phd_course_name && (
                          <EduBlock
                            title={educational_details?.phd_course_name}
                            department={
                              educational_details?.phd_department_name
                            }
                            university={
                              educational_details?.phd_university_name ===
                              'Other'
                                ? educational_details?.other_phd_university
                                : educational_details?.phd_university_name
                            }
                            institution={
                              educational_details?.phd_institution_name ===
                              'Other'
                                ? educational_details?.other_phd_institution
                                : educational_details?.phd_institution_name
                            }
                            date={
                              educational_details?.phd_year_of_completion &&
                              moment(
                                educational_details?.phd_year_of_completion
                              ).format('DD-MMM-YYYY')
                            }
                          />
                        )}
                        {/* Postgraduate */}
                        {educational_details?.pg_course_name && (
                          <EduBlock
                            title={educational_details?.pg_course_name}
                            department={educational_details?.pg_department_name}
                            university={
                              educational_details?.pg_university_name ===
                              'Other'
                                ? educational_details?.other_pg_university
                                : educational_details?.pg_university_name
                            }
                            institution={
                              educational_details?.pg_institution_name ===
                              'Other'
                                ? educational_details?.other_pg_institution
                                : educational_details?.pg_institution_name
                            }
                            date={
                              educational_details?.pg_year_of_completion &&
                              moment(
                                educational_details?.pg_year_of_completion
                              ).format('DD-MMM-YYYY')
                            }
                          />
                        )}
                        {/* Undergraduate */}
                        {educational_details?.ug_course_name && (
                          <EduBlock
                            title={educational_details?.ug_course_name}
                            department={educational_details?.ug_department_name}
                            university={
                              educational_details?.ug_university_name ===
                              'Other'
                                ? educational_details?.other_ug_university
                                : educational_details?.ug_university_name
                            }
                            institution={
                              educational_details?.ug_institution_name ===
                              'Other'
                                ? educational_details?.other_ug_institution
                                : educational_details?.ug_institution_name
                            }
                            date={
                              educational_details?.ug_year_of_completion &&
                              moment(
                                educational_details?.ug_year_of_completion
                              ).format('DD-MMM-YYYY')
                            }
                          />
                        )}
                      </>
                      <hr className="b-d1d1" />
                    </Col>
                  )}
                </Row>
              </div>
              <div className="br-f4fc cps-14 cpe-14">
                <Row>
                  {educational_details?.area_of_interest && (
                    <Col md={12}>
                      <InfoBlockWithList
                        icon={icons.bArea}
                        label="RESEARCH INTEREST AND DRIVES"
                        items={
                          educational_details?.area_of_interest &&
                          educational_details?.area_of_interest.split(',')
                        }
                      />
                      <hr className="b-d1d1" />
                    </Col>
                  )}
                </Row>
              </div>
              {publication?.length !== 0 && publication?.length > 0 && (
                <div className="cps-14 cpe-14">
                  <div className="fa-center gap-2 flex-nowrap cmb-22">
                    <div className="text-14-500 color-48c0">
                      RESEARCH PUBLICATIONS (WoS AND/OR SCOPUS)
                    </div>
                  </div>
                  {publication?.map((ele, index) => {
                    return <PubBlock data={ele} />;
                  })}
                  <hr className="b-d1d1" />
                </div>
              )}
              {achievements?.length !== 0 && achievements.length > 0 && (
                <div>
                  <div className="cps-14 cpe-14">
                    <div className="fa-center gap-2 flex-nowrap cmb-22">
                      <div className="text-14-500 color-48c0">
                        AWARDS AND RECOGNITION
                      </div>
                    </div>
                    {achievements.map((ele) => {
                      return (
                        <AcheiBlock
                          title={`${ele?.event_name} (${ele?.award_name} )`}
                        />
                      );
                    })}
                    <hr className="b-d1d1" />
                  </div>
                </div>
              )}
              <div className="br-f4fc cps-14 cpe-14">
                <Row>
                  {about?.disciplines && (
                    <Col md={12}>
                      <InfoBlockWithList
                        icon={icons.bDisipline}
                        label="DISCIPLINES"
                        items={about?.disciplines?.split(',')}
                      />
                      <hr className="b-d1d1" />
                    </Col>
                  )}
                </Row>
              </div>
              <div className="br-f4fc cps-14 cpe-14">
                <Row>
                  {about?.languages && (
                    <Col md={12}>
                      <InfoBlockWithList
                        icon={icons.bLanguague}
                        label="LANGUAGES KNOWN"
                        items={about?.languages && about?.languages.split(',')}
                      />
                      <hr className="b-d1d1" />
                    </Col>
                  )}
                </Row>
              </div>
              <div className="br-f4fc cps-14 cpe-14">
                <Row>
                  <Col md={12}>
                    <InfoBlockWithList
                      icon={icons.bLanguague}
                      label="DECLARATION"
                      items={[
                        'I hereby declare that the above information is correct to the best of my knowledge and belief.',
                      ]}
                      isDeclare={true}
                    />
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default CVPreview;
